import deepmerge from 'deepmerge';
export const oneOf = function (value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (validList[i] === value) {
      return true;
    }
  }
  return false;
};
export const setThemeJson = function (list, validList) {
  const skinList = [];
  validList.map(item => {
    list.map(items => {
      if (item.theme == items) {
        skinList.push(item);
      }
    });
  });
  return skinList;
};
export const typeOf = function (obj) {
  const toString = Object.prototype.toString;
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  return map[toString.call(obj)];
};
export const isString = function (str) {
  return typeOf(str) == 'string';
};
export const isFunction = function (fn) {
  return typeOf(fn) == 'function';
};
export const isPlainObject = function (obj) {
  return typeOf(obj) == 'object';
};
export const isDate = function (date) {
  return typeOf(date) == 'date';
};
export const isArray = function (array) {
  return Array.isArray(array);
};
export const deepCopy = function (data, customizer) {
  const t = typeOf(data);
  let o;

  if (t === 'array') {
    o = [];
  } else if (t === 'object') {
    o = {};
  } else {
    return data;
  }

  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
      if(customizer){
        if(customizer(i, data[i])!==false){
          o.push(deepCopy(data[i],customizer));
        }
      }else{
        o.push(deepCopy(data[i],customizer));
      }
    }
  } else if (t === 'object') {
    for (let i in data) {
      if(customizer){
        if(customizer(i, data[i])!==false){
          o[i] = deepCopy(data[i], customizer);
        }
      }else{
        o[i] = deepCopy(data[i], customizer);
      }
    }
  }
  return o;
};
//千分位
export const delimiter = function (val) {
  return String(val).replace(/\B(?=(\d{3})+$)/g, ',');
};
export function mergeOld() {
  let arr = Array.prototype.slice.call(arguments);
  return deepmerge.all(arr, {
    arrayMerge: function (destinationArray, sourceArray) {
      return sourceArray || [];
    }
  });
}
// 由一个组件，向上找到最近的指定组件
export function findComponentUpward(context, componentName) {
  let parent = context.$parent;
  let name = parent.$options.name;

  while (parent && (!name || [componentName].indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) name = parent.$options.name;
  }
  return parent;
}
// 由一个组件，向下找到最近的指定组件
export function findComponentDownward(context, componentName) {
  const childrens = context.$children;
  let children = null;

  if (childrens.length) {
    for (const child of childrens) {
      const name = child.$options.name;

      if (name === componentName) {
        children = child;
        break;
      } else {
        children = findComponentDownward(child, componentName);
        if (children) break;
      }
    }
  }
  return children;
}

/**
 * 合并
 * @param {Object} obj1
 * @param {Object} obj2
 * @return Object
 */
export const merge = (obj1, obj2, replace = true) => {
  for (let p in obj2) {
    try {
      if (obj2[p].constructor === Object) {
        if (!obj1[p]) {
          obj1[p] = {};
        }
        obj1[p] = merge(obj1[p], obj2[p]);
      } else if (obj2[p].constructor === Array) {
        if (replace) {
          let _obj = merge(obj1[p] || [], obj2[p]);
          //判断数组长度是否一致
          if (_obj.length !== obj2[p].length) {
            _obj = _obj.slice(0, obj2[p].length);
          }
          obj1[p] = _obj;
        } else {
          obj1[p] = (obj1[p] || []).concat(obj2[p]);
        }
      } else {
        obj1[p] = obj2[p];
      }
    } catch (e) {
      obj1[p] = obj2[p];
    }
  }

  return obj1;
};
/**
 * 创建echart空对象
 * @param {Object} config 标准配置
 * @param {Object||Array} data 数据
 * @param {Object} other 自定义或series配置
 * @return Object {config,data,other}
 */
export const createChartTemp = (config = {}, data = [], other = {}) => {
  return {
    config,
    data,
    other
  };
};

export const units = ['%', '万人', '人', '万', ''];

export const formatThousands = (num, fixed = 2) => {
  return Number((num / 10000).toFixed(fixed));
};
export const toFixed = (num, fixed = 2) => {
  return Number(num.toFixed(fixed));
};

/**
 * 对请求的原始数据进行转换符合charts 需要
 * @param {Array} data 原数据
 * @param {Array||Object} config 转出的格式 数组||对象
 * @return {Array||Object}
 */
export const convertArrayData = (data = [], config = [], other = {}) => {
  // nameKeys 表示把原数据的哪些key转换为新数据key=name1,name2.....
  // valueKeys 表示把原数据的哪些key转换为新数据key=value1,value2.....
  const type = typeOf(config);
  let _data = [];
  if (config.length === 0) {
    return [];
  }
  if (type === 'object') {
    const item = config;
    data.forEach(d => {
      let _item = {};
      //set name
      if (item.nameKeys && item.nameKeys.length) {
        item.nameKeys.forEach((nameKey, index) => {
          const nameValue =
            (item.nameValues && item.nameValues[index]) || d[nameKey];
          _item[`name${index + 1}`] = nameValue;
        });
      } else if (item.nameValues && item.nameValues.length) {
        item.nameValues.forEach((nameValue, index) => {
          _item[`name${index + 1}`] = nameValue;
        });
      }
      //set value
      if (item.valueKeys && item.valueKeys.length) {
        item.valueKeys.forEach((valueKey, index) => {
          const value =
            (item.valueValues && item.valueValues[index]) || d[valueKey];
          _item[`value${index + 1}`] = value || 0;
        });
      } else if (item.valueValues && item.valueValues.length) {
        item.valueValues.forEach((value, index) => {
          _item[`value${index + 1}`] = value || 0;
        });
      }

      // set other
      for (let key in item) {
        if (
          key !== 'nameKeys' &&
          key !== 'nameValues' &&
          key !== 'valueKeys' &&
          key !== 'valueValues'
        ) {
          _item[key] = item[key];
        }
      }
      for (let k in d) {
        //true 表示不存在
        const nameKeyIndex = item.nameKeys && item.nameKeys.indexOf(k) === -1;
        const nameValueIndex =
          item.nameValues && item.nameValues.indexOf(k) === -1;
        const valueKeyIndex =
          item.valueKeys && item.valueKeys.indexOf(k) === -1;
        const valueValueIndex =
          item.valueValues && item.valueValues.indexOf(k) === -1;
        if (
          (nameKeyIndex === undefined || nameKeyIndex === true) &&
          (nameValueIndex === undefined || nameValueIndex === true) &&
          (valueKeyIndex === undefined || valueKeyIndex === true) &&
          (valueValueIndex === undefined || valueValueIndex === true)
        ) {
          _item[k] = d[k];
        }
      }
      if (other.label) {
        _item.label = d[other.label];
      }
      _data.push(_item);
    });
  } else if (type === 'array') {
    config.forEach(item => {
      let _item = {};
      data.forEach((d, index) => {
        //set name
        if (item.nameKeys && item.nameKeys.length) {
          item.nameKeys.forEach(nameKey => {
            const nameValue =
              (item.nameValues && item.nameValues[index]) || d[nameKey];
            _item[`name${index + 1}`] = nameValue;
          });
        } else if (item.nameValues && item.nameValues.length) {
          item.nameValues.forEach(nameValue => {
            _item[`name${index + 1}`] = nameValue;
          });
        }
        //set value
        if (item.valueKeys && item.valueKeys.length) {
          item.valueKeys.forEach(valueKey => {
            const value =
              (item.valueValues && item.valueValues[index]) || d[valueKey];
            _item[`value${index + 1}`] = value || 0;
          });
        } else if (item.valueValues && item.valueValues.length) {
          item.valueValues.forEach(value => {
            _item[`value${index + 1}`] = value || 0;
          });
        }
      });
      // set other
      for (let key in item) {
        if (
          key !== 'nameKeys' &&
          key !== 'nameValues' &&
          key !== 'valueKeys' &&
          key !== 'valueValues'
        ) {
          _item[key] = item[key];
        }
      }
      _data.push(_item);
    });
  }
  return _data;
};
/**
 * 对请求的原始数据进行转换符合charts 需要
 * @param {Object} data 原数据
 * @param {Array||Object} config 转出的格式 数组||对象
 * @return {Array||Object}
 */
export const convertObjectData = (data = {}, config = {}) => {
  // nameKeys 表示把原数据的哪些key转换为新数据key=name1,name2.....
  // valueKeys 表示把原数据的哪些key转换为新数据key=value1,value2.....
  const keys = Object.keys(data);
  const type = typeOf(config);
  let _data = type === 'object' ? {} : [];
  if (keys.length === 0) {
    return _data;
  }
  if (type === 'object') {
    _data = convertObjectData(data, [config])[0];
  } else if (type === 'array') {
    for (let i = 0; i < config.length; i++) {
      const item = config[i];
      const _item = {};
      //set name
      if (item.nameKeys && item.nameKeys.length) {
        item.nameKeys.forEach((nameKey, index) => {
          const nameValue =
            (item.nameValues && item.nameValues[index]) || data[nameKey];
          _item[`name${index + 1}`] = nameValue;
        });
      } else if (item.nameValues && item.nameValues.length) {
        item.nameValues.forEach((nameValue, index) => {
          _item[`name${index + 1}`] = nameValue;
        });
      }
      //set value
      if (item.valueKeys && item.valueKeys.length) {
        item.valueKeys.forEach((valueKey, index) => {
          const value =
            (item.valueValues && item.valueValues[index]) || data[valueKey];
          _item[`value${index + 1}`] = value || 0;
        });
      } else if (item.valueValues && item.valueValues.length) {
        item.valueValues.forEach((value, index) => {
          _item[`value${index + 1}`] = value || 0;
        });
      }
      // set other
      for (let key in item) {
        if (
          key !== 'nameKeys' &&
          key !== 'nameValues' &&
          key !== 'valueKeys' &&
          key !== 'valueValues'
        ) {
          _item[key] = item[key];
        }
      }
      _data.push(_item);
    }
  }
  return _data;
};
/**
 * 转换时间格式
 * @param  {String} str 时间 '2018-12'
 * @return {String} 时间 '2018.12'
 */
export const dateTransition = str => {
  return str.indexOf('-') > -1 ? str.replace('-', '.') : str.replace('.', '-');
};
export const interceptCityName = str => {
  const index = str.indexOf('市');
  return str.substring(0, index > -1 ? index : str.length);
};
export const debounce = (fn, speed = 300) => {
  let time;
  return function () {
    let that = this;
    let args = arguments;
    clearTimeout(time);
    time = setTimeout(function () {
      fn.apply(that, args);
    }, speed);
  };
};
export const autoSize = () => {
  const standardWidth = process.env.VUE_APP_SCREEN_WIDTH;
  const standardHeight = process.env.VUE_APP_SCREEN_HEIGHT;
  const isEnvPro = process.env.NODE_ENV == 'production';
  if (isEnvPro) {
    document.body.style.overflow = "hidden";
  }
  const clientWidth = document.documentElement.clientWidth;
  const clientHeight = document.documentElement.clientHeight;
  const scaleWidth = clientWidth / standardWidth;
  const scaleHeight = clientHeight / standardHeight;
  let style = document.body.style;

  style.width = `${standardWidth}px`;
  style.height = `${standardHeight}px`;
  isEnvPro && (style.transform = `scale(${scaleWidth},${scaleHeight})`);
  style.transformOrigin = 'left top';
};
/**
 * 根据path获取对象的值
 * @param  {[type]} object [description]
 * @param  {[type]} path   [description]
 * @return {[type]}        [description]
 */
export function getValueByPath(object, path) {
  let pathArr = path.split('.'),
    key;

  while (object && pathArr.length) {
    key = pathArr.shift();

    if (!key) continue;

    object = object[key];

    if (object === null || object === undefined) {
      object = '';
    }
  }

  return object;
}

/**
 * 日期格式化， by haozhenjia
 * @param  {[type]} date [description]
 * @param  {String} fmt  [description]
 * @return {[type]}      [description]
 */
export function dateFormat(date, fmt = 'yyyy-MM-dd hh:mm') {
  let o,
    isTimestamp = /^\d{0,10}$/;

  date = isDate(date)
    ? date
    : isTimestamp.test(date)
      ? new Date(date * 1000)
      : new Date(date);
  o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };

  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  return fmt;
}

export function getMonthList(
  dateStr,
  { number = 3, descFormat = 'yyyy-MM', valueFormat = 'yyyy-MM' }
) {
  let date = new Date(dateStr),
    year = date.getFullYear(),
    month = date.getMonth(),
    list = [];

  while (number > 0) {
    list.push({
      value: dateFormat(date, valueFormat),
      desc: dateFormat(date, descFormat)
    });
    if (!number--) break;

    if (month) {
      month -= 1;
    } else {
      month = 11;
      year -= 1;
    }

    date.setFullYear(year, month);
  }

  return list;
}

/**
 * 将location.search，解析成对象
 * @return {[type]} [description]
 */
export function getLocationParams() {
  let segments = location.search.replace(/^\?/, '').split('&'),
    params = {};

  segments.forEach(segment => {
    if (!segment) return;

    let [key, value] = segment.split('=');

    params[key] = value;
  });

  return params;
}

/**
 * 将小数转换成百分数
 * @param  {[type]} num [description]
 * @return {[type]}     [description]
 */
export function floatToPercent(num, toFixed = 2, addUnit) {
  let isFloat = /^-?\d+\.\d+$/,
    percent = num;

  if (isFloat.test(num)) {
    percent = (Number(num) * 100).toFixed(toFixed);
  }

  return addUnit ? percent + '%' : +percent;
}
/**
 * 判断一个数字是否是奇数
 * @param  {[type]}  num [description]
 * @return {Boolean}     [description]
 */
export function isOdd(num) {
  return num % 2
}
/**
 * 判断一个数字是否是偶数
 * @param  {[type]}  num [description]
 * @return {Boolean}     [description]
 */
export function isEven(num) {
  return !isOdd(num)
}
/**
 * randomWord 产生任意长度随机字母数字组合
 * @param randomFlag 是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 * @param min
 * @param max
 * @returns {string}
 */
export function randomWord(randomFlag, min, max) {
  let str = "",
    range = min,
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min;
  }
  for (let i = 0; i < range; i++) {
    const pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
}

export const nextId = (function(){
  let id = 1;
  return function(){
    return id++;
  }
})()

export const copyTextClipboard = (text) => {
  if (window.clipboardData) {
    /* ie浏览器 */
    window.clipboardData.setData('Text', text)
  } else {
    let input = document.createElement('input')
    input.type = 'text'
    input.value = text
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
  }
}

export function normalizeUrl(url){
  if(url&&url.charAt(url.length-1)!=='/'){
    return url+'/';
  }else{
    return url;
  }
}

export function traverseTree(root, handler, childFileName='children'){
  let stack = [{parent:null, node:root}];
  while (stack.length) {
    let comp = stack.pop();
    let children = comp.node[childFileName];
    if (children&&Array.isArray(children)) {
      stack.push(...children.map(c=>{
        return {parent:comp, node:c};
      }));
    }
    handler.call(comp, comp.node, comp.parent?comp.parent.node:comp.parent, root);
  }
}